import { t } from '../locale'

interface ServiceCostSubtitleProps {
  label: string
  points?: number
  // Number of people an AML check will screen (client + representatives +
  // beneficial owners). Shown only when the check covers more than the client.
  personCount?: number
  // Of those people, how many are already covered by today's cache and therefore
  // not charged again.
  cachedCount?: number
}

function ServiceCostSubtitle({
  label,
  points,
  personCount,
  cachedCount,
}: ServiceCostSubtitleProps) {
  return (
    <>
      <strong>{label}</strong>
      {personCount !== undefined && personCount > 1 && (
        <div className='small mt-1'>
          {personCount} {t('amlCheckPersonsInfo')}
        </div>
      )}
      {cachedCount !== undefined && cachedCount > 0 && (
        <div className='small mt-1'>
          {cachedCount} {t('amlCheckCachedInfo')}
        </div>
      )}
      {points !== undefined && points > 0 && (
        <div className='small mt-1'>
          <strong>{points}</strong> <strong>{t('punkteWerdenVerrechnet')}</strong>
        </div>
      )}
    </>
  )
}

export default ServiceCostSubtitle
